<template>
	<div class="view-payment-breakdown">
		<Modal
			:show="showMakePayment"
			content_class="col-12 col-md-9 col-lg-7 col-xl-6 confirm-modal"
		>
			<template slot="content" v-if="invoice_details">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Pay Invoice</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showMakePayment', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div class="card payment-card">
									<div class="txt-main">
										You are about to pay
										<span class="amount"
											>{{
												invoice_details.currency || '¤'
											}}
											{{
												utils.numberWithCommas2(
													invoice_details.total_amount,
												)
											}}</span
										>
										for ref:
										<span class="ref tx-uppercase">{{
											invoice_details.parent_fee_invoice_system_ref
										}}</span>
									</div>

									<div class="balance">
										Total balance is:
										<span class="total-amount"
											>{{
												invoice_details.acc_balance_currency
											}}
											{{
												utils.numberWithCommas2(
													Math.round(
														invoice_details.total_amount *
															100,
													) / 100,
												)
											}}</span
										>
										<br />
										Available balance is:
										<span
											class="amount"
											:class="{
												'tx-red':
													invoice_details.total_amount >
													acc_balance,
											}"
											>{{
												invoice_details.currency ||
												'KES'
											}}
											{{
												utils.numberWithCommas2(
													Math.round(
														acc_balance * 100,
													) / 100,
												)
											}}</span
										>
									</div>

									<div class="txt-main">
										<!-- *By proceeding you are agreeing to the <a _target="blank" href="#">Terms and Conditions</a> -->
										<p class="terms-text">
											By proceeding, you are agreeing to
											the
											<a
												href="https://agency.nexus.ke/static/media/Nexus%20General%20Terms%20and%20Conditions%2027.7.2020.fa4a0a2ac647c2df199c.pdf"
												target="_blank"
												rel="noopener noreferrer"
												class="terms-link"
											>
												Terms and Conditions </a
											>.
										</p>
										<Form
											classBinding="row"
											:ref="
												FeeInvoiceModel.forms
													.accept_terms.name
											"
											:forms="
												FeeInvoiceModel.forms
													.accept_terms.forms
											"
											:formData="
												FeeInvoiceModel.forms
													.accept_terms.data
											"
										/>
									</div>

									<div class="button-box">
										<button
											class="btn btn-green btn-long"
											v-if="
												invoice_details.total_amount <=
												acc_balance
											"
											@click="
												paySchoolInvoice({
													accept_terms:
														$refs[
															FeeInvoiceModel
																.forms
																.accept_terms
																.name
														],
												})
											"
										>
											Pay
										</button>
										<div v-else>
											<button
												class="btn btn-primary btn-long"
												@click="topUp()"
											>
												Top Up
											</button>
										</div>

										<div
											v-if="
												invoice_breakdown &&
												invoice_breakdown.invoice &&
												invoice_breakdown.invoice
													.finance_option
											"
										>
											<div class="balance">
												Amount available for finance :
												<span class="total-amount">
													{{
														utils.numberWithCommas2(
															invoice_breakdown
																.invoice
																.finance_option
																.amt_available_for_finance,
														)
													}}</span
												>
												<br />
											</div>
											<div class="balance">
												Max loan tenor :
												<span class="total-amount">
													{{
														invoice_breakdown
															.invoice
															.finance_option
															.max_loan_tenor
													}}
													Months
												</span>
												<br />
											</div>
											<button
												class="btn btn-yellow btn-long"
												v-if="
													invoice_breakdown.invoice
														.finance_option
														.can_be_financed
												"
												@click="
													openRequestInvoiceFinance({
														accept_terms:
															$refs[
																FeeInvoiceModel
																	.forms
																	.accept_terms
																	.name
															],
													})
												"
											>
												Get Finance
											</button>
											<div class="txt-message" v-else>
												No Finance:
												{{
													invoice_breakdown.invoice
														.finance_option
														.unfinanced_reason
												}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('../templates/others/modal'),
		Form: () => import('@/libs/clarks/components/form'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
	},
	computed: {
		...mapGetters([
			'loading',
			'FeeInvoiceModel',
			'payment_breakdown',
			'get_finance_data',
			'invoice_breakdown',
			'selected_invoice',
			'acc_balance_currency',
			'invoice_details',
			'showMakePayment',
			'acc_balance',
		]),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		...mapActions(['openRequestInvoiceFinance', 'paySchoolInvoice']),
		topUp() {
			this.$router.push({ name: 'TopUpOptions' });
		},
	},
	mounted() {},
};
</script>

<style lang="less">
.view-payment-breakdown {
	.total-amount {
		font-weight: 600;
		font-size: 13px;
	}

	.txt-message {
		font-size: 13px;
		color: var(--ne-red);
		margin: 10px 0 0 0;
		text-align: center;
	}
}
</style>
